import React from 'react'
import PropTypes from 'prop-types'
import { Form, Radio } from 'antd'
import css from '../../common/Form.css'

const radioStyle = {
  display: 'block',
}

const TierSelector = ({ onChange, value }) => (
  <Form.Item
    label="Automated Messaging Tier"
    className={css.itemLabel}
    key="tier"
  >
    <Radio.Group
      name="tier"
      onChange={onChange}
      value={value}
      className={css.label}
    >
      <Radio value={1} style={radioStyle}>
        Tier 1: Text and email. Max of 2 text messages per slider. (Also used
        for practices without reminders.)
      </Radio>
      <Radio value={2} style={radioStyle}>
        Tier 2: Text and email. Max of 4 text messages per slider.
      </Radio>
      <Radio value={3} disabled style={radioStyle}>
        Tier 3: Not used.
      </Radio>
      <Radio value={4} style={radioStyle}>
        Tier 4: Email only.
      </Radio>
    </Radio.Group>
  </Form.Item>
)

TierSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
}

TierSelector.defaultProps = {
  value: null,
}

export default TierSelector



// WEBPACK FOOTER //
// ./src/AddPractice/Products/TierSelector.js